import { Provider } from '@angular/core'
import { LocaleService } from 'shared-services'
import {
  IdentityConfig,
  UserGetterService,
  UserService,
} from 'identity-services'
import { identityConfigToken } from './identity-config.token'
import { userGetterServiceToken } from './user-getter-service.provider'

export const userServiceProvider: Provider = {
  provide: UserService,
  useFactory: (
    identityConfig: IdentityConfig,
    localeService: LocaleService,
    userGetterService: UserGetterService,
  ): UserService => {
    return new UserService(identityConfig, localeService, userGetterService)
  },
  deps: [identityConfigToken, LocaleService, userGetterServiceToken],
}
